import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { SelectedWorkspaceStore, isUserProfileIncomplete } from '../stores/selected-workspace.store';
import { Observable, first, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileCompletionGuard implements CanActivate, CanLoad {
  constructor(
    private workspaceStore: SelectedWorkspaceStore,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkProfile(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = '/' + segments.map((s) => s.path).join('/');
    return this.checkProfile(url);
  }

  private checkProfile(returnUrl: string): Observable<boolean> {
    return this.workspaceStore.user$.pipe(
      first(),
      map((user) => {
        if (!user || user.id === 0) {
          return true;
        }

        if (isUserProfileIncomplete(user)) {
          this.router.navigate(['/auth/registration/additional'], {
            queryParams: { from: returnUrl },
          });
          return false;
        }

        return true;
      }),
    );
  }
}

